import React, { useEffect } from 'react';
import useUserInfo from '../../Hooks/useUserInfo';
import './Gauth.css';
import { useAudio } from '../../Providers/AudioProvider';
import { Base_Url } from '../../apis/baseurl';
import { decryptMessage } from '../../utils/crypto';
import { LoginWithGoogleApi } from '../../apis/user';

const Gauth = () => {
  const { updateUserInfo } = useUserInfo();
  // useEffect(() => {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const success = urlParams.get('success');
  //   const token = urlParams.get('token');
  //   console.log(urlParams,'urlParams');
  //   console.log(success,'success');
    
    
  //   if (success ) {
  //     // Store token and update state
  //     localStorage.setItem('authToken', token);
      
  //     updateUserInfo(prev => ({
  //       ...prev,
  //       isLoggedIn: true,
  //       currentComponent: 'Tv',  // Force redirect to main interface
  //       currentComponentText: 'TVPage'
  //     }));

  //     // Clean URL while keeping the path
  //     window.history.replaceState({}, '', '/');
  //   }
  // }, []);
  //http://localhost:3001/?name=j88NkmpPkeOjrVlD7ZmLNQ==&googleId=YWjE0bP2hXzc7RYCj0kLQMuLlAgNhXG6xmQ7Ot/63Cg=
  
 
  const handleGoogleAuth = () => {
    const returnUrl = encodeURIComponent(window.location.origin);
    window.location.href = `${Base_Url?.base_url}/webapp/auth?provider=google`;
  };
  // const handleGoogleAuth = async () => {
  //       const returnUrl = encodeURIComponent(window.location.origin);
  //   window.location.href = `${Base_Url?.base_url}/webapp/auth?provider=google`;
  //   try {
  //     const response = LoginWithGoogleApi()
  //     if (response.ok) {

        
  //       const data = await response.json();
  //       if (data.name && data.googleId) {
  //         localStorage.setItem("UserName_Web", (data.name));
  //         localStorage.setItem("GoogleId_Web", (data.googleId));
  //         // Update user state or redirect as needed
  //         updateUserInfo(prev => ({
  //           ...prev,
  //           isLoggedIn: true,
  //           currentComponent: 'Tv',
  //           currentComponentText: 'TVPage'
  //         }));
  //       }
  //     } else {
  //       console.error('Authentication failed');
  //     }
  //   } catch (error) {
  //     console.error('Error during authentication:', error);
  //   }
  // };
   const RefId = localStorage.getItem("RefId");
  const handleTelegramAuth = () => {
    window.location.href = RefId?`https://t.me/the_meme_tv_bot?startapp=${RefId}`: "https://t.me/the_meme_tv_bot?startapp"; // Replace with your bot link or auth endpoint
  };
  const XChannel = () => {
    window.open("https://x.com/thememe_tv", "_blank");
  };

  const InstaChannel = () => {
    window.open("https://instagram.com/thememe_tv", "_blank");
  };

  return (
    <div className="gauth-container">
      <div className="gauth-content">
        <div className="logo-container">
          <img src="https://d1ccopf5cw1hft.cloudfront.net/s3data/MemeTv-logo.png" alt="The Meme TV" className="meme-tv-logo" />
        </div>
        
        <div className="auth-buttons">
          <button className="google-auth-btn" onClick={handleGoogleAuth} style={{pointerEvents:'fill'}}>
            <img src="https://d1ccopf5cw1hft.cloudfront.net/s3data/google.png" alt="Google logo" />
            <span>LOG IN WITH GOOGLE</span>
          </button>
          
          <button className="telegram-auth-btn" onClick={handleTelegramAuth} style={{pointerEvents:'fill'}}>
            <img src="https://d1ccopf5cw1hft.cloudfront.net/s3data/telegram-auth.png" alt="Telegram logo" />
            <span>LOG IN WITH TELEGRAM</span>
          </button>
        </div>
        
        <div className="social-icons">
          <a onClick={() => {
                      InstaChannel();
                        }}  target="_blank" rel="noopener noreferrer">
            <img src="https://d1ccopf5cw1hft.cloudfront.net/s3data/insta-auth.png" alt="Instagram" />
          </a>
          <a onClick={() => {
                      XChannel();
                        }} target="_blank" rel="noopener noreferrer">
            <img src="https://d1ccopf5cw1hft.cloudfront.net/s3data/x-auth.png" alt="Twitter" />
          </a>
        </div>
        
       
      </div>

      <div className="promo-text">
          <p>Play. Earn. Repeat. The Meme TV rewards you for every second you spend playing. Turn your screen time into rewards!</p>
        </div>
    </div>
  );
};

export default Gauth;